import React from "react";
import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
interface Service {
  _id: string;
  serviceName: string;
}
interface PrescriptionApprovalFiltersProps {
  isDarkMode: boolean;
  searchFilter: string;
  setSearchFilter: (value: string) => void;
  serviceFilter: string;
  setServiceFilter: (value: string) => void;
  services: Service[];
}

export function PrescriptionApprovalFilters({
  isDarkMode,
  searchFilter,
  setSearchFilter,
  serviceFilter,
  setServiceFilter,
  services,
}: PrescriptionApprovalFiltersProps) {
  return (
    <div className="flex flex-col sm:flex-row gap-4">
      {/* Search Bar */}
      <div className="flex-1">
        <div className="relative">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" />
          <Input
            placeholder="Search by patient name, prescriber, or medication..."
            value={searchFilter}
            onChange={(e) => setSearchFilter(e.target.value)}
            className={`pl-10 ${isDarkMode
                ? "bg-gray-800 border-gray-700 text-white placeholder-gray-400"
                : "bg-white border-gray-300"
              }`}
          />
        </div>
      </div>

      {/* Service Filter */}
      <div className="w-full sm:w-48">
        <Select value={serviceFilter} onValueChange={setServiceFilter}>
          <SelectTrigger
            className={
              isDarkMode ? "bg-gray-800 border-gray-700 text-white" : ""
            }
          >
            <SelectValue placeholder="Filter by service" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All Services</SelectItem>
            {services
              .filter(
                (service) =>
                  service.serviceType !== 1 && service.serviceType !== 3
              )
              .map((service) => (
                <SelectItem key={service._id} value={service.serviceName}>
                  {service.serviceName}
                </SelectItem>
              ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
}
